import { QuestionMark } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Drawer, Modal, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { ArrowRightIcon } from 'assets/icons';

import { useMediaQueries } from 'hooks';
import { useNavigate } from 'react-router';

const TroubleshootModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { isTabletOrGreater } = useMediaQueries();
  const navigate = useNavigate();
  const RootComponent = isTabletOrGreater ? Modal : Drawer;

  return (
    <RootComponent open={open} onClose={onClose} anchor="bottom">
      <StyledRootDiv className="SystemOfflinePopup">
        <div className="closeIcon">
          <CloseIcon onClick={onClose} />
        </div>
        <div className="troubleshootTitle">
          <QuestionMark className="questionMarkIcon" />
          <Typography variant="h5">
            {t('shared.SystemOffline.troubleshootingStartsAtHome')}
          </Typography>
        </div>
        <div className="troubleshootText">
          <Typography variant="body1">
            {t('shared.SystemOffline.troubleshootingStartsAtHomeDescription')}
          </Typography>
          <Typography variant="body1" className="bottom-text">
            {t('shared.SystemOffline.troubleshootingStartsAtHomeDescription2')}
          </Typography>
        </div>
        <Button
          variant="text"
          className="redirect-button"
          onClick={() => {
            navigate('/home', { replace: true });
            onClose();
          }}
        >
          <Typography>{t('shared.SystemOffline.takeMeToHome')}</Typography>
          <ArrowRightIcon />
        </Button>
      </StyledRootDiv>
    </RootComponent>
  );
};

export default TroubleshootModal;

const StyledRootDiv = styled('div')(({ theme: { palette, breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: palette.elevation.overlay1,
  color: palette.whiteEmphasis.high,
  [breakpoints.up('sm')]: {
    padding: '32px 42px',
    borderRadius: '8px',
    position: 'fixed',
    inset: 0,
    maxWidth: '560px',
    width: 'fit-content',
    height: 'fit-content',
    margin: 'auto',
  },

  [breakpoints.down('sm')]: { padding: '24px' },

  '.closeIcon': {
    position: 'absolute',
    top: '16px',
    right: '16px',
    cursor: 'pointer',
  },
  '.questionMarkIcon': {
    border: '2px solid white',
    borderRadius: '50%',
    padding: '2px',
    marginRight: '12px',
    fontSize: '30px',
  },
  '.troubleshootTitle': {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '16px',
    color: palette.whiteEmphasis.high,
  },
  '.troubleshootText': {
    p: {
      color: palette.whiteEmphasis.high,
      lineHeight: '24px',
    },
    marginTop: '16px',
    textAlign: 'center',
    '.bottom-text': {
      marginTop: '32px',
    },
    marginBottom: '32px',
  },
  '.redirect-button': {
    width: 'fit-content',
    textTransform: 'none',
    background: '#2a2a2a',
    margin: '0 auto',
    gap: '8px',
    padding: '2px 16px',
  },
}));
